import { container, singleton } from "tsyringe";
import PostApi from "api/clapaction/projects/[id]/config/forum/posts/PostApi";
import PostIdApi from "api/clapaction/projects/[id]/config/forum/posts/[postId]/PostIdApi";
import ForumPostRequestResource from "common/resources/Project/Config/Forum/ForumPostRequestResource";
import ForumPostResponseResource from "common/resources/Project/Config/Forum/ForumPostResponseResource";
import toValidationError from "utils/toValidationError";

@singleton()
export default class ForumPostService {
	private postApi: PostApi = container.resolve(PostApi);
	private postIdApi: PostIdApi = container.resolve(PostIdApi);

	public async getGeneralPosts(projectId: string): Promise<ForumPostResponseResource[]> {
		return this.postApi.getGeneralPosts(projectId).catch(toValidationError);
	}

	public async getCastingPosts(projectId: string): Promise<ForumPostResponseResource[]> {
		return this.postApi.getCastingPosts(projectId).catch(toValidationError);
	}

	public async getArchivedPosts(projectId: string): Promise<ForumPostResponseResource[]> {
		return this.postApi.getArchivedPosts(projectId).catch(toValidationError);
	}

	public async getById(projectId: string, postId: string): Promise<ForumPostResponseResource> {
		return this.postIdApi.getByPostId(projectId, postId).catch(toValidationError);
	}

	public async downloadImage(projectId: string, postId: string): Promise<Blob> {
		return this.postIdApi.downloadImage(projectId, postId).catch(toValidationError);
	}

	public async create(projectId: string, request: ForumPostRequestResource, image?: File): Promise<ForumPostResponseResource> {
		return this.postApi.create(projectId, request, image).catch(toValidationError);
	}

	public async update(projectId: string, postId: string, request: ForumPostRequestResource, image?: File): Promise<ForumPostResponseResource> {
		return this.postIdApi.update(projectId, postId, request, image).catch(toValidationError);
	}

	public async archive(projectId: string, postId: string): Promise<ForumPostResponseResource> {
		return this.postIdApi.archive(projectId, postId).catch(toValidationError);
	}

	public async restore(projectId: string, postId: string): Promise<ForumPostResponseResource> {
		return this.postIdApi.restore(projectId, postId).catch(toValidationError);
	}

	public async delete(projectId: string, postId: string): Promise<void> {
		return this.postIdApi.delete(projectId, postId).catch(toValidationError);
	}
}
